import { render, staticRenderFns } from "./TDview.vue?vue&type=template&id=464b8938"
import script from "./TDview.vue?vue&type=script&lang=js"
export * from "./TDview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports